module.exports = "<dispatcher-page></dispatcher-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/dispatcher.html
// module id = 1585
// module chunks = 0